import React, { useContext } from "react";
import { RESOURCE_NAME } from "common/authorization";
import { AuthContext } from "../Authorization/AuthContext";
import { Actions } from "../Common/ActionCell";
import { ActionsProps } from "../Inputs/DropdownMenu";
import { useShareWorkflowModal } from "./ShareWorkflowModal";

interface WorkflowActionsProps {
  workflowId: string;
  workflowName: string;
  canShare: boolean;
}

export const WorkflowActions = ({
  workflowId,
  workflowName,
  canShare,
}: WorkflowActionsProps) => {
  const { authorized } = useContext(AuthContext);

  const [showShareModal] = useShareWorkflowModal({
    entityType: "workflow",
    entityId: workflowId,
    entityName: workflowName,
  });

  const canShareWorkflow =
    canShare &&
    authorized({ permission: "share", resource: RESOURCE_NAME.WORKFLOW });

  if (!canShareWorkflow) {
    return null;
  }

  const actions: ActionsProps[] = [
    {
      label: "Add collaborator",
      onClick: showShareModal,
    },
  ];

  return <Actions actions={actions} />;
};
